/**
 * Builds the promotion leaf rows for a cross-category promotion.
 *
 * Each row receives category-scoped KPI totals from calculateProductsTotal(p.products)
 * as the source of truth. Full-promotion KPIs are deliberately NOT spread here; they
 * would overwrite the per-category values and produce incorrect forecast figures.
 * higherKPIs (computed from the full promotion vs alternative mechanics) is preserved
 * so the highlight logic in the grid still works correctly.
 *
 * @param {object}   opts
 * @param {object}   opts.productsByUnitCategory  - keyed by "<unitKey>:<catKey>:<promoId>"
 * @param {object}   opts.promotionRowData        - common fields shared across all leaf rows
 * @param {object}   opts.higherKPIs              - map of KPI keys where alt-mechanics beat the promo total
 * @param {Function} opts.calculateProductsTotal  - function(products) => KPI totals object
 * @returns {object[]} leaf rows for promotionSeparatedByUnitCategory
 */
const buildMultiCategoryLeafRows = ({
    productsByUnitCategory,
    promotionRowData,
    higherKPIs,
    calculateProductsTotal,
}) => {
    return Object.values(productsByUnitCategory).map(p => ({
        ...promotionRowData,
        id: p.id,
        hierarchy: p.hierarchy,
        ...calculateProductsTotal(p.products),
        higherKPIs,
    }));
};

export default buildMultiCategoryLeafRows;
